import React, { Component }         from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { invokeSetAddPARQAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/PARQForm.css';

// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class PARQForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            email: " - - ",
            cardio_heart_disease_cb: false, // changes uncontrolled to controlled input; removes error
            cardio_pulmonary_disease_cb: false,
            cardio_metabolic_disease_cb: false,
            cardio_family_history_cb: false,
            cardio_blood_pressure_cb: false,
            cardio_high_cholesterol_cb: false,
            cardio_smoking_cb: false,
            cardio_sedentary_cb: false,
            signs_age_tf: 0,
            signs_shortness_breath_cb: false,
            signs_irregular_heartrate_cb: false,
            ortho_osteoporosis_cb: false,
            ortho_arthritis_cb: false,
            ortho_back_pain_cb: false,
            ortho_musculoskeletal_pain_cb: false,
            ortho_hernia_cb: false,
            ortho_surgery_cb: false,
            ortho_other_cb: false,
            lifestyle_sleep_tf: false,
            lifestyle_water_tf: false,
            lifestyle_caffeine_tf: false,
            lifestyle_alcohol_tf: false,
            lifestyle_travel_often_cb: false,
            lifestyle_hypoglycemia_cb: false,
            lifestyle_gi_disorder_cb: false,
            lifestyle_high_triglycerides_cb: false,
            lifestyle_cancer_cb: false,
            lifestyle_pre_post_natal_cb: false,
            lifestyle_anemia_cb: false,
            lifestyle_food_allergy_cb: false,
            lifestyle_other_cb: false,
            lifestyle_rd_referral_cb: false,
            health_heart_condition_rb: "",
            health_chest_pain_during_activity_rb: "",
            health_chest_pain_no_activity_rb: "",
            health_dizziness_lose_balance_rb: "",
            health_joint_problem_rb: "",
            health_blood_pressure_drugs_rb: "",
            health_other_reasons_rb: "",
            health_medical_clearance_rb: "",
            health_clearance_date_tf: ""

            // activity_occupation_tf, activity_office_worker_cb, activity_works_on_feet_cb, activity_heavy_work_cb, activity_seated_hours_tf, activity_standing_hours_tf, activity_commute_time_tf, parq_notes_ta
            // add other cbs
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState){
        console.log("getDerivedStateFromProps!!! ");
        console.log("nextProps.dob: " + nextProps.dob);
        if(nextProps.dob !== prevState.dob){

            ////  Ensure email has a value in it or it will override validated existing values  ////
            if(nextProps.email != undefined)
                return { email:         nextProps.email,
                         dob:           nextProps.dob,
                         phone:         nextProps.phone,
                         phone_evening: nextProps.phone_evening,
                         emergency_contact_name:          nextProps.emergency_contact_name,
                         emergency_contact_phone_day:     nextProps.emergency_contact_phone_day,
                         emergency_contact_phone_evening: nextProps.emergency_contact_phone_evening
                       };
        }
        else return null;

    }

    componentDidUpdate (prevProps, prevState) {
        //console.log("componentDidUpdate");
    }

    getTodaysDate () {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!

        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        var current_date = mm + '/' + dd + '/' + yyyy;

        return current_date;
    }


    async componentDidMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getPARQAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var email                           = results.data2[0].email;
                var phone                           = results.data2[0].phone;
                var phone_evening                   = results.data2[0].phone_evening;
                var dob                             = results.data2[0].dob;
                var emergency_contact_name          = results.data2[0].emergency_contact_name;
                var emergency_contact_phone_day     = results.data2[0].emergency_contact_phone_day;
                var emergency_contact_phone_evening = results.data2[0].emergency_contact_phone_evening;
                var todays_date_tf                  = results.data[0].todays_date_tf;
                var private_trainer                 = results.data[0].private_trainer;
                var doctors_name                    = results.data[0].doctors_name;
                var doctors_phone                   = results.data[0].doctors_phone;
                var physical_date                   = results.data[0].physical_date;

                /****************   Cardio Risks   ****************/
                var cardio_heart_disease_cb         = results.data[0].cardio_heart_disease_cb;
                var cardio_pulmonary_disease_cb     = results.data[0].cardio_pulmonary_disease_cb;
                var cardio_metabolic_disease_cb     = results.data[0].cardio_metabolic_disease_cb;
                var cardio_family_history_cb        = results.data[0].cardio_family_history_cb
                var cardio_blood_pressure_cb        = results.data[0].cardio_blood_pressure_cb
                var cardio_high_cholesterol_cb      = results.data[0].cardio_high_cholesterol_cb;
                var cardio_smoking_cb               = results.data[0].cardio_smoking_cb;
                var cardio_sedentary_cb             = results.data[0].cardio_sedentary_cb;

                /****************   Signs/Symptoms   ****************/
                var signs_age_tf                    = results.data[0].signs_age_tf;
                var signs_shortness_breath_cb       = results.data[0].signs_shortness_breath_cb;
                var signs_irregular_heartrate_cb    = results.data[0].signs_irregular_heartrate_cb;

                /****************   Orthopedic   ****************/
                var ortho_osteoporosis_cb           = results.data[0].ortho_osteoporosis_cb;
                var ortho_arthritis_cb              = results.data[0].ortho_arthritis_cb;
                var ortho_back_pain_cb              = results.data[0].ortho_back_pain_cb;
                var ortho_musculoskeletal_pain_cb   = results.data[0].ortho_musculoskeletal_pain_cb;
                var ortho_hernia_cb                 = results.data[0].ortho_hernia_cb;
                var ortho_surgery_cb                = results.data[0].ortho_surgery_cb;
                var ortho_other_cb                  = results.data[0].ortho_other_cb;

                /****************   Lifestyle   ****************/
                var lifestyle_stress_personal_rb            = results.data[0].lifestyle_stress_personal_rb;
                var lifestyle_stress_work_rb                = results.data[0].lifestyle_stress_work_rb;
                var lifestyle_energy_rb                     = results.data[0].lifestyle_energy_rb;

                var lifestyle_sleep_tf                      = results.data[0].lifestyle_sleep_tf;
                var lifestyle_water_tf                      = results.data[0].lifestyle_water_tf;
                var lifestyle_caffeine_tf                   = results.data[0].lifestyle_caffeine_tf;
                var lifestyle_alcohol_tf                    = results.data[0].lifestyle_alcohol_tf;

                var lifestyle_travel_often_cb               = results.data[0].lifestyle_travel_often_cb;
                var lifestyle_hypoglycemia_cb               = results.data[0].lifestyle_hypoglycemia_cb;
                var lifestyle_gi_disorder_cb                = results.data[0].lifestyle_gi_disorder_cb;
                var lifestyle_high_triglycerides_cb         = results.data[0].lifestyle_high_triglycerides_cb;
                var lifestyle_cancer_cb                     = results.data[0].lifestyle_cancer_cb;
                var lifestyle_pre_post_natal_cb             = results.data[0].lifestyle_pre_post_natal_cb;
                var lifestyle_anemia_cb                     = results.data[0].lifestyle_anemia_cb;
                var lifestyle_food_allergy_cb               = results.data[0].lifestyle_food_allergy_cb;
                var lifestyle_other_cb                      = results.data[0].lifestyle_other_cb;
                var lifestyle_rd_referral_cb                = results.data[0].lifestyle_rd_referral_cb;

                /****************   Health Questions   ****************/
                var health_heart_condition_rb               = results.data[0].health_heart_condition_rb;
                var health_chest_pain_during_activity_rb    = results.data[0].health_chest_pain_during_activity_rb;
                var health_chest_pain_no_activity_rb        = results.data[0].health_chest_pain_no_activity_rb;
                var health_dizziness_lose_balance_rb        = results.data[0].health_dizziness_lose_balance_rb;
                var health_joint_problem_rb                 = results.data[0].health_joint_problem_rb;
                var health_blood_pressure_drugs_rb          = results.data[0].health_blood_pressure_drugs_rb;
                var health_other_reasons_rb                 = results.data[0].health_other_reasons_rb;
                var health_medical_clearance_rb             = results.data[0].health_medical_clearance_rb;
                var health_clearance_date_tf                = results.data[0].health_clearance_date_tf;

                /*****************   Activity Profile    *****************/
                var activity_occupation_tf                  = results.data[0].activity_occupation_tf;
                var activity_office_worker_cb               = results.data[0].activity_office_worker_cb;
                var activity_works_on_feet_cb               = results.data[0].activity_works_on_feet_cb;
                var activity_heavy_work_cb                  = results.data[0].activity_heavy_work_cb;
                var activity_seated_hours_tf                = results.data[0].activity_seated_hours_tf;
                var activity_standing_hours_tf              = results.data[0].activity_standing_hours_tf;
                var activity_commute_time_tf                = results.data[0].activity_commute_time_tf;

                /*****************   Notes    *****************/
                var parq_notes_ta                           = results.data[0].parq_notes_ta;

                /*****************   CARDIO HEALTH    *****************/
                // Values come out as string but must become bolean
                if(cardio_heart_disease_cb != true) cardio_heart_disease_cb = false;
                if(cardio_pulmonary_disease_cb != true) cardio_pulmonary_disease_cb = false;
                if(cardio_metabolic_disease_cb != true) cardio_metabolic_disease_cb = false;
                if(cardio_family_history_cb != true) cardio_family_history_cb = false;
                if(cardio_blood_pressure_cb != true) cardio_blood_pressure_cb = false;
                if(cardio_high_cholesterol_cb != true) cardio_high_cholesterol_cb = false;
                if(cardio_smoking_cb != true) cardio_smoking_cb = false;
                if(cardio_sedentary_cb != true) cardio_sedentary_cb = false;

                /****************   Signs/Symptoms   ****************/
                if(signs_age_tf == null) signs_age_tf = 0;
                if(signs_shortness_breath_cb != true) signs_shortness_breath_cb = false;
                if(signs_irregular_heartrate_cb != true) signs_irregular_heartrate_cb = false;

                /****************   Orthopedic   ****************/
                if(ortho_osteoporosis_cb != true) ortho_osteoporosis_cb = false;
                if(ortho_arthritis_cb != true) ortho_arthritis_cb = false;
                if(ortho_back_pain_cb != true) ortho_back_pain_cb = false;
                if(ortho_musculoskeletal_pain_cb != true) ortho_musculoskeletal_pain_cb = false;
                if(ortho_hernia_cb != true) ortho_hernia_cb = false;
                if(ortho_surgery_cb != true) ortho_surgery_cb = false;
                if(ortho_other_cb != true) ortho_other_cb = false;


                /****************   Lifestyle   ****************/
                // lifestyle_stress_personal_rb, lifestyle_stress_work_rb, lifestyle_energy_rb
                if(lifestyle_sleep_tf == null) lifestyle_sleep_tf = "";
                if(lifestyle_water_tf == null) lifestyle_water_tf = "";
                if(lifestyle_caffeine_tf == null) lifestyle_caffeine_tf = "";
                if(lifestyle_alcohol_tf == null) lifestyle_alcohol_tf = "";

                if(lifestyle_travel_often_cb != true) lifestyle_travel_often_cb = false;
                if(lifestyle_hypoglycemia_cb != true) lifestyle_hypoglycemia_cb = false;
                if(lifestyle_gi_disorder_cb != true) lifestyle_gi_disorder_cb = false;
                if(lifestyle_high_triglycerides_cb != true) lifestyle_high_triglycerides_cb = false;
                if(lifestyle_cancer_cb != true) lifestyle_cancer_cb = false;
                if(lifestyle_pre_post_natal_cb != true) lifestyle_pre_post_natal_cb = false;
                if(lifestyle_anemia_cb != true) lifestyle_anemia_cb = false;
                if(lifestyle_food_allergy_cb != true) lifestyle_food_allergy_cb = false;
                if(lifestyle_other_cb != true) lifestyle_other_cb = false;
                //lifestyle_rd_referral_cb

                /****************   Health Questions   ****************
                if(health_heart_condition_rb        == null) health_heart_condition_rb = "no";
                if(health_chest_pain_during_activity_rb != true) health_chest_pain_during_activity_rb = false;
                if(health_chest_pain_no_activity_rb != true) health_chest_pain_no_activity_rb = false;
                if(health_dizziness_lose_balance_rb != true) health_dizziness_lose_balance_rb = false;
                if(health_joint_problem_rb          != true) health_joint_problem_rb = false;
                if(health_blood_pressure_drugs_rb   != true) health_blood_pressure_drugs_rb = false;
                if(health_other_reasons_rb          != true) health_other_reasons_rb = false;
                if(health_medical_clearance_rb      != true) health_medical_clearance_rb = false;*/
                //health_clearance_date_tf                = results.data[0].health_clearance_date_tf= false;

                this.setState({

                    /****************   Member Information   ****************/
                    email:                           email,
                    phone:                           phone,
                    phone_evening:                   phone_evening,
                    todays_date_tf:                  todays_date_tf,
                    dob:                             dob,
                    private_trainer:                 private_trainer,
                    emergency_contact_name:          emergency_contact_name,
                    emergency_contact_phone_day:     emergency_contact_phone_day,
                    emergency_contact_phone_evening: emergency_contact_phone_evening,
                    doctors_name:                    doctors_name,
                    doctors_phone:                   doctors_phone,
                    physical_date:                   physical_date,

                    cardio_heart_disease_cb:        cardio_heart_disease_cb,
                    cardio_pulmonary_disease_cb:    cardio_pulmonary_disease_cb,
                    cardio_metabolic_disease_cb:    cardio_metabolic_disease_cb,
                    cardio_family_history_cb:       cardio_family_history_cb,
                    cardio_blood_pressure_cb:       cardio_blood_pressure_cb,
                    cardio_high_cholesterol_cb:     cardio_high_cholesterol_cb,
                    cardio_smoking_cb:              cardio_smoking_cb,
                    cardio_sedentary_cb:            cardio_sedentary_cb,

                    /****************   Signs/Symptoms   ****************/
                    signs_age_tf:                   signs_age_tf,
                    signs_shortness_breath_cb:      signs_shortness_breath_cb,
                    signs_irregular_heartrate_cb:   signs_irregular_heartrate_cb,

                    /****************   Orthopedic   ****************/
                    ortho_osteoporosis_cb:          ortho_osteoporosis_cb,
                    ortho_arthritis_cb:             ortho_arthritis_cb,
                    ortho_back_pain_cb:             ortho_back_pain_cb,
                    ortho_musculoskeletal_pain_cb:  ortho_musculoskeletal_pain_cb,
                    ortho_hernia_cb:                ortho_hernia_cb,
                    ortho_surgery_cb:               ortho_surgery_cb,
                    ortho_other_cb:                 ortho_other_cb,

                    /****************   Lifestyle   ****************/
                    lifestyle_stress_personal_rb:   lifestyle_stress_personal_rb,
                    lifestyle_stress_work_rb:       lifestyle_stress_work_rb,
                    lifestyle_energy_rb:            lifestyle_energy_rb,

                    lifestyle_sleep_tf:             lifestyle_sleep_tf,
                    lifestyle_water_tf:             lifestyle_water_tf,
                    lifestyle_caffeine_tf:          lifestyle_caffeine_tf,
                    lifestyle_alcohol_tf:           lifestyle_alcohol_tf,

                    lifestyle_travel_often_cb      : lifestyle_travel_often_cb,
                    lifestyle_hypoglycemia_cb      : lifestyle_hypoglycemia_cb,
                    lifestyle_gi_disorder_cb       : lifestyle_gi_disorder_cb,
                    lifestyle_high_triglycerides_cb: lifestyle_high_triglycerides_cb,
                    lifestyle_cancer_cb            : lifestyle_cancer_cb,
                    lifestyle_pre_post_natal_cb    : lifestyle_pre_post_natal_cb,
                    lifestyle_anemia_cb            : lifestyle_anemia_cb,
                    lifestyle_food_allergy_cb      : lifestyle_food_allergy_cb,
                    lifestyle_other_cb             : lifestyle_other_cb,
                    lifestyle_rd_referral_cb       : lifestyle_rd_referral_cb,

                    health_heart_condition_rb               : health_heart_condition_rb,
                    health_chest_pain_during_activity_rb    : health_chest_pain_during_activity_rb,
                    health_chest_pain_no_activity_rb        : health_chest_pain_no_activity_rb,
                    health_dizziness_lose_balance_rb        : health_dizziness_lose_balance_rb,
                    health_joint_problem_rb                 : health_joint_problem_rb,
                    health_blood_pressure_drugs_rb          : health_blood_pressure_drugs_rb,
                    health_other_reasons_rb                 : health_other_reasons_rb,
                    health_medical_clearance_rb             : health_medical_clearance_rb,
                    health_clearance_date_tf                : health_clearance_date_tf,

                    /*****************   Activity Profile    *****************/
                    activity_occupation_tf                  : activity_occupation_tf,
                    activity_office_worker_cb               : activity_office_worker_cb,
                    activity_works_on_feet_cb               : activity_works_on_feet_cb,
                    activity_heavy_work_cb                  : activity_heavy_work_cb,
                    activity_seated_hours_tf                : activity_seated_hours_tf,
                    activity_standing_hours_tf              : activity_standing_hours_tf,
                    activity_commute_time_tf                : activity_commute_time_tf,

                    /*****************   Notes    *****************/
                    parq_notes_ta                           : parq_notes_ta
                });
            }
        }
    }

    handleInputChange(event) {
          const target = event.target;
          const value = target.type === 'checkbox' ? target.checked : target.value;
          const name = target.name;

          //console.log("name: " + name);
          //console.log("value: " + value);
          this.setState({
            [name]: value
          });
    }

    handleSubmit = async event => {
        event.preventDefault();
        console.log("SUBMIT .....");
        var client_id                   = this.props.clientId;
        var assessment_id               = this.props.assessmentId;
        var assessment_type             = 6; // spinal rom is #4 in dropdown


        /****************   Member Information   ****************/
        var email                           = this.state.email;
        var phone                           = this.state.phone;
        var phone_evening                   = this.state.phone_evening;
        var todays_date_tf                  = this.state.todays_date_tf;
        var dob                             = this.state.dob;
        var private_trainer                 = this.state.private_trainer;
        var emergency_contact_name          = this.state.emergency_contact_name;
        var emergency_contact_phone_day     = this.state.emergency_contact_phone_day;
        var emergency_contact_phone_evening = this.state.emergency_contact_phone_evening;
        var doctors_name                    = this.state.doctors_name;
        var doctors_phone                   = this.state.doctors_phone;
        var physical_date                   = this.state.physical_date;

        /****************   Cardiovascular   ****************/
        var cardio_heart_disease_cb         = this.state.cardio_heart_disease_cb;
        var cardio_pulmonary_disease_cb     = this.state.cardio_pulmonary_disease_cb;
        var cardio_metabolic_disease_cb     = this.state.cardio_metabolic_disease_cb;
        var cardio_family_history_cb        = this.state.cardio_family_history_cb;
        var cardio_blood_pressure_cb        = this.state.cardio_blood_pressure_cb;
        var cardio_high_cholesterol_cb      = this.state.cardio_high_cholesterol_cb;
        var cardio_smoking_cb               = this.state.cardio_smoking_cb;
        var cardio_sedentary_cb             = this.state.cardio_sedentary_cb;

        /****************   Signs/Symptoms   ****************/
        var signs_age_tf                    = this.state.signs_age_tf;
        var signs_shortness_breath_cb       = this.state.signs_shortness_breath_cb;
        var signs_irregular_heartrate_cb    = this.state.signs_irregular_heartrate_cb;

        /****************   Orthopedic   ****************/
        var ortho_osteoporosis_cb           = this.state.ortho_osteoporosis_cb;
        var ortho_arthritis_cb              = this.state.ortho_arthritis_cb;
        var ortho_back_pain_cb              = this.state.ortho_back_pain_cb;
        var ortho_musculoskeletal_pain_cb   = this.state.ortho_musculoskeletal_pain_cb;
        var ortho_hernia_cb                 = this.state.ortho_hernia_cb;
        var ortho_surgery_cb                = this.state.ortho_surgery_cb;
        var ortho_other_cb                  = this.state.ortho_other_cb;

        /****************   Lifestyle   ****************/
        var lifestyle_stress_personal_rb    = this.state.lifestyle_stress_personal_rb;
        var lifestyle_stress_work_rb        = this.state.lifestyle_stress_work_rb;
        var lifestyle_energy_rb             = this.state.lifestyle_energy_rb;

        var lifestyle_sleep_tf              = this.state.lifestyle_sleep_tf;
        var lifestyle_water_tf              = this.state.lifestyle_water_tf;
        var lifestyle_caffeine_tf           = this.state.lifestyle_caffeine_tf;
        var lifestyle_alcohol_tf            = this.state.lifestyle_alcohol_tf;

        var lifestyle_travel_often_cb       = this.state.lifestyle_travel_often_cb;
        var lifestyle_hypoglycemia_cb       = this.state.lifestyle_hypoglycemia_cb;
        var lifestyle_gi_disorder_cb        = this.state.lifestyle_gi_disorder_cb;
        var lifestyle_high_triglycerides_cb = this.state.lifestyle_high_triglycerides_cb;
        var lifestyle_cancer_cb             = this.state.lifestyle_cancer_cb;
        var lifestyle_pre_post_natal_cb     = this.state.lifestyle_pre_post_natal_cb;
        var lifestyle_anemia_cb             = this.state.lifestyle_anemia_cb;
        var lifestyle_food_allergy_cb       = this.state.lifestyle_food_allergy_cb;
        var lifestyle_other_cb              = this.state.lifestyle_other_cb;
        var lifestyle_rd_referral_cb        = this.state.lifestyle_rd_referral_cb;

        /****************   Health Questions   ****************/
        var health_heart_condition_rb               = this.state.health_heart_condition_rb;
        var health_chest_pain_during_activity_rb    = this.state.health_chest_pain_during_activity_rb;
        var health_chest_pain_no_activity_rb        = this.state.health_chest_pain_no_activity_rb;
        var health_dizziness_lose_balance_rb        = this.state.health_dizziness_lose_balance_rb;
        var health_joint_problem_rb                 = this.state.health_joint_problem_rb;
        var health_blood_pressure_drugs_rb          = this.state.health_blood_pressure_drugs_rb;
        var health_other_reasons_rb                 = this.state.health_other_reasons_rb;
        var health_medical_clearance_rb             = this.state.health_medical_clearance_rb;
        var health_clearance_date_tf                = this.state.health_clearance_date_tf;

        /*****************   Activity Profile    *****************/
        var activity_occupation_tf                  = this.state.activity_occupation_tf;
        var activity_office_worker_cb               = this.state.activity_office_worker_cb;
        var activity_works_on_feet_cb               = this.state.activity_works_on_feet_cb;
        var activity_heavy_work_cb                  = this.state.activity_heavy_work_cb;
        var activity_seated_hours_tf                = this.state.activity_seated_hours_tf;
        var activity_standing_hours_tf              = this.state.activity_standing_hours_tf;
        var activity_commute_time_tf                = this.state.activity_commute_time_tf;

        /*****************   Notes    *****************/
        var parq_notes_ta                           = this.state.parq_notes_ta;

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })


        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddPARQAssessment(action, assessment_id, client_id, cardio_heart_disease_cb, cardio_pulmonary_disease_cb, cardio_metabolic_disease_cb, cardio_family_history_cb, cardio_blood_pressure_cb, cardio_high_cholesterol_cb, cardio_smoking_cb, cardio_sedentary_cb, signs_age_tf, signs_shortness_breath_cb, signs_irregular_heartrate_cb, ortho_osteoporosis_cb, ortho_arthritis_cb, ortho_back_pain_cb, ortho_musculoskeletal_pain_cb, ortho_hernia_cb, ortho_surgery_cb,  ortho_other_cb, lifestyle_stress_personal_rb, lifestyle_stress_work_rb, lifestyle_energy_rb, lifestyle_sleep_tf, lifestyle_water_tf, lifestyle_caffeine_tf, lifestyle_alcohol_tf, lifestyle_travel_often_cb, lifestyle_hypoglycemia_cb, lifestyle_gi_disorder_cb, lifestyle_high_triglycerides_cb, lifestyle_cancer_cb, lifestyle_pre_post_natal_cb, lifestyle_anemia_cb, lifestyle_food_allergy_cb, lifestyle_other_cb, lifestyle_rd_referral_cb, health_heart_condition_rb, health_chest_pain_during_activity_rb, health_chest_pain_no_activity_rb, health_dizziness_lose_balance_rb, health_joint_problem_rb, health_blood_pressure_drugs_rb, health_other_reasons_rb, health_medical_clearance_rb, health_clearance_date_tf, activity_occupation_tf, activity_office_worker_cb, activity_works_on_feet_cb, activity_heavy_work_cb, activity_seated_hours_tf, activity_standing_hours_tf, activity_commute_time_tf, parq_notes_ta, email, phone, phone_evening, todays_date_tf, dob,  private_trainer, emergency_contact_name, emergency_contact_phone_day, emergency_contact_phone_evening, doctors_name, doctors_phone, physical_date)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    render() {
        var phone_subtitle = <span style={{fontSize:16, color: "#666"}}>(###) ###-####</span>
        var date_subtitle  = <span style={{fontSize:16, color: "#666"}}>(mm/dd/yyyy)</span>
        //var email_subtitle = <span style={{fontSize:16, color: "#666"}}>()</span>

        var todays_date_tf = this.state.todays_date_tf;

        if(todays_date_tf == null || todays_date_tf == undefined) {
            todays_date_tf = this.getTodaysDate();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <form onSubmit={this.handleSubmit} className="form">


                        <div className="iconAddExercise25pxVertSpacer"></div>
                    { /****************************************************************************/ }
                        { /***********************  Member Information  ***************************/ }
                        <div className="parqSectionTitle">
                            <span className="glyphicon glyphicon-user parqMemberIcon"/>
                            Member Information (select a member name above first)
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">
                                    <span className="assessmentPARQ_labelCB">
                                        Email
                                        <br/>
                                            {this.state.email}

                                        { /*}<input
                                          name      = "email"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.email}
                                          onChange  = {this.handleInputChange} />*/ }
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Day Phone {phone_subtitle}
                                        <br/>
                                        <input
                                          name      = "phone"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.phone}
                                          onChange  = {this.handleInputChange} />
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Evening Phone {phone_subtitle}
                                        <br/>
                                        <input
                                          name      = "phone_evening"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.phone_evening}
                                          onChange  = {this.handleInputChange} />
                                    </span>
                        </div>
                        <div className="iconAddExercise35pxVertSpacer"></div>
                        { /***********************  ROW 2  ************************/ }
                        <div className="grid parqRowFullWidth parqColored50pxHeight">
                                    <span className="assessmentPARQ_labelCB">
                                        Date of Birth {date_subtitle}
                                        <br/>
                                        <input
                                          name      = "dob"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.dob}
                                          onChange  = {this.handleInputChange} />
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Today's Date {date_subtitle}
                                        <br/>
                                        <input
                                          name      = "todays_date_tf"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {todays_date_tf}
                                          onChange  = {this.handleInputChange} />
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Private Trainer
                                        <br/>
                                        <input
                                          name      = "private_trainer"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.private_trainer}
                                          onChange  = {this.handleInputChange} />
                                    </span>
                        </div>

                        <div className="iconAddExercise25pxVertSpacer"></div>
                        { /***********************  ROW 3  ************************/ }
                        <div className="grid parqRowFullWidth ">
                                    <span className="assessmentPARQ_labelCB">
                                        Emergency Contact Name
                                        <br/>
                                        <input
                                          name      = "emergency_contact_name"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.emergency_contact_name}
                                          onChange  = {this.handleInputChange} />
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Day Phone {phone_subtitle}
                                        <br/>
                                        <input
                                          name      = "emergency_contact_phone_day"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.emergency_contact_phone_day}
                                          onChange  = {this.handleInputChange} />
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Evening Phone {phone_subtitle}
                                        <br/>
                                        <input
                                          name      = "emergency_contact_phone_evening"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.emergency_contact_phone_evening}
                                          onChange  = {this.handleInputChange} />
                                    </span>
                        </div>
                        <div className="iconAddExercise35pxVertSpacer"></div>
                        { /***********************  MEMBER PROFILE: ROW 4  ************************/ }
                        <div className="grid parqRowFullWidth parqColored50pxHeight">
                                    <span className="assessmentPARQ_labelCB">
                                        Doctor's Name
                                        <br/>
                                        <input
                                          name      = "doctors_name"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.doctors_name}
                                          onChange  = {this.handleInputChange} />
                                    </span>
                                    <span className="assessmentPARQ_labelCB">
                                        Office Phone {phone_subtitle}
                                        <br/>
                                        <input
                                          name      = "doctors_phone"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.doctors_phone}
                                          onChange  = {this.handleInputChange} />
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        Last Physical {date_subtitle}
                                        <br/>
                                        <input
                                          name      = "physical_date"
                                          className = "assessmentPARQ_textfield_long_width"
                                          value     = {this.state.physical_date}
                                          onChange  = {this.handleInputChange} />
                                    </span>
                        </div>

                        <div className="iconAddExerciseVertSpacer"></div>

                        { /*******************************************************************/ }
                        { /***********************  CARDIVASCULAR  ***************************/ }
                        <div className="parqSectionTitle">
                            <FontAwesomeIcon icon="heartbeat" className="parqCardioIcon" />
                            <span className="parqCardioTitle">
                                Cardiovascular Risks
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">
                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Cardio Heart Disease:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "cardio_heart_disease_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_heart_disease_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half">Cardio Pulmonary Disease: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "cardio_pulmonary_disease_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_pulmonary_disease_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">Cardio Metabolic Disease: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "cardio_metabolic_disease_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_metabolic_disease_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Cardio Family History:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "cardio_family_history_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_family_history_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half">Cardio Blood Pressure: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "cardio_blood_pressure_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_blood_pressure_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">Cardio High Cholesterol: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "cardio_high_cholesterol_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_high_cholesterol_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>

                        { /***********************  CARDIVASCULAR ROW 3  ***************************/ }
                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Cardio Smoking:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "cardio_smoking_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_smoking_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half">Cardio Sedentary: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "cardio_sedentary_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.cardio_sedentary_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">&nbsp;</span>
                                        <span className="assessmentPARQ_right_half"></span>
                                    </span>
                        </div>

                        { /***********************  END: CARDIVASCULAR  ***************************/ }
                        { /************************************************************************/ }


                        { /***************************************************************************/ }
                        { /***********************  BEGIN: SIGNS/SYMPTOMS  ***************************/ }
                        <div className="parqSectionTitle">
                            <FontAwesomeIcon icon="vials" className="parqSignsIcon" />
                            <span className="parqCardioTitle">
                                Signs/Symptoms
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_small_width">Age: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half_small_width">
                                              <input
                                                name="signs_age_tf"
                                                type="number"
                                                className = "assessmentPARQ_textfield_short_width"
                                                value     = {this.state.signs_age_tf}
                                                onChange  = {this.handleInputChange} />
                                        </span>
                                    </span>
                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Shortness of Breath: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "signs_shortness_breath_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.signs_shortness_breath_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half_medium_width">Irregular Heart Rate: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "signs_irregular_heartrate_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.signs_irregular_heartrate_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                        </div>

                        { /***********************  END: SIGNS/SYMPTOMS  ***************************/ }
                        { /***************************************************************************/ }


                        { /*******************************************************************/ }
                        { /***********************  Orthopedic/Other  ***************************/ }
                        <div className="parqSectionTitle">
                            <FontAwesomeIcon icon="male" className="parqMaleIcon" />
                            <span className="">
                                Orthopedic/Other
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Osteoporosis:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "ortho_osteoporosis_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_osteoporosis_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half_medium_width">Arthritis/Joint Pain:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "ortho_arthritis_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_arthritis_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">Back Pain/Spine Disorder:</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "ortho_back_pain_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_back_pain_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Surgery:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "ortho_surgery_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_surgery_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half_medium_width">Hernia:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "ortho_hernia_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_hernia_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">Musculoskeletal Pain:</span>
                                        <span className="assessmentPARQ_right_half">
                                              <input
                                                  name     = "ortho_musculoskeletal_pain_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_musculoskeletal_pain_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>
                        </div>

                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_medium_width">Other:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "ortho_other_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.ortho_other_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">&nbsp;</span>
                                        <span className="assessmentPARQ_right_half"></span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">&nbsp;</span>
                                        <span className="assessmentPARQ_right_half"></span>
                                    </span>
                        </div>

                        { /***********************  END: Orthopedic/Other  ***************************/ }
                        { /***************************************************************************/ }


                        { /***************************************************************/ }
                        { /***********************  LIFESTYLE  ***************************/ }
                        <div className="parqSectionTitle">
                            <FontAwesomeIcon icon="utensils" className="parqLifestyleIcon" />
                            <span className="parqLifestyleTitle">
                                Lifestyle/Dietary Factors
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">

                                    <span className="assessmentPARQ_row_long">
                                        <span className="assessmentPARQ_left_half">Stress Level - Personal:</span>

                                        <span className="assessmentPARQ_right_half">
                                            <input type     = "radio"
                                                   name     = "lifestyle_stress_personal_rb"
                                                   value    = "low"
                                                   checked  = {this.state.lifestyle_stress_personal_rb === "low"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Low
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                     value    = "medium"
                                                     name     = "lifestyle_stress_personal_rb"
                                                     checked  = {this.state.lifestyle_stress_personal_rb === "medium"}
                                                     onChange = {this.handleInputChange}/> &nbsp; Medium
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   value    = "high"
                                                   name     = "lifestyle_stress_personal_rb"
                                                   checked  = {this.state.lifestyle_stress_personal_rb === "high"}
                                                   onChange = {this.handleInputChange}/> &nbsp;High
                                        </span>
                                    </span>
                        </div>
                        <div className="grid parqRowFullWidth">

                                <span className="assessmentPARQ_row_long">
                                    <span className="assessmentPARQ_left_half">Stress Level - Work:</span>

                                    <span className="assessmentPARQ_right_half">
                                        <input type     = "radio"
                                               name     = "lifestyle_stress_work_rb"
                                               value    = "low"
                                               checked  = {this.state.lifestyle_stress_work_rb === "low"}
                                               onChange = {this.handleInputChange} /> &nbsp; Low
                                        &nbsp; &nbsp; &nbsp;
                                        <input type     = "radio"
                                                 value    = "medium"
                                                 name     = "lifestyle_stress_work_rb"
                                                 checked  = {this.state.lifestyle_stress_work_rb === "medium"}
                                                 onChange = {this.handleInputChange}/> &nbsp; Medium
                                        &nbsp; &nbsp; &nbsp;
                                        <input type     = "radio"
                                               value    = "high"
                                               name     = "lifestyle_stress_work_rb"
                                               checked  = {this.state.lifestyle_stress_work_rb === "high"}
                                               onChange = {this.handleInputChange}/> &nbsp;High
                                    </span>
                                </span>
                        </div>

                        <div className="grid parqRowFullWidth">

                                <span className="assessmentPARQ_row_long">
                                    <span className="assessmentPARQ_left_half">Energy Level:</span>

                                    <span className="assessmentPARQ_right_half">
                                        <input type     = "radio"
                                               name     = "lifestyle_energy_rb"
                                               value    = "low"
                                               checked  = {this.state.lifestyle_energy_rb === "low"}
                                               onChange = {this.handleInputChange} /> &nbsp; Low
                                        &nbsp; &nbsp; &nbsp;
                                        <input type     = "radio"
                                                 value    = "medium"
                                                 name     = "lifestyle_energy_rb"
                                                 checked  = {this.state.lifestyle_energy_rb === "medium"}
                                                 onChange = {this.handleInputChange}/> &nbsp; Medium
                                        &nbsp; &nbsp; &nbsp;
                                        <input type     = "radio"
                                               value    = "high"
                                               name     = "lifestyle_energy_rb"
                                               checked  = {this.state.lifestyle_energy_rb === "high"}
                                               onChange = {this.handleInputChange}/> &nbsp;High
                                    </span>
                                </span>
                        </div>
                        <hr style={{borderTop: "2px solid #ccc", width: "95%"}}/>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowHalfWidth">
                                        <span className="assessmentPARQ_left_half_medium_width">Sleep Hours:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                            <input
                                              name      = "lifestyle_sleep_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.lifestyle_sleep_tf}
                                              onChange  = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="parqRowHalfWidth">
                                        <span className="assessmentPARQ_left_half_medium_width">Water Intake: </span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                            <input
                                              name      = "lifestyle_water_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.lifestyle_water_tf}
                                              onChange  = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>

                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowHalfWidth">
                                        <span className="assessmentPARQ_left_half_medium_width">Caffeine Intake:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                            <input
                                              name      = "lifestyle_caffeine_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.lifestyle_caffeine_tf}
                                              onChange  = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="parqRowHalfWidth">
                                        <span className="assessmentPARQ_left_half_medium_width">Alcohol Intake:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                            <input
                                              name      = "lifestyle_alcohol_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.lifestyle_alcohol_tf}
                                              onChange  = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        <hr style={{borderTop: "2px solid #ccc", width: "95%"}}/>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Travel Often:</span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_travel_often_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_travel_often_cb}
                                                onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Hypoglycemia: </span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_hypoglycemia_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_hypoglycemia_cb}
                                                onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">G.I. Disorder:</span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_gi_disorder_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_gi_disorder_cb}
                                                onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Cancer:</span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_cancer_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_cancer_cb}
                                                onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Pre/Postnatal:</span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_pre_post_natal_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_pre_post_natal_cb}
                                                onChange = {this.handleInputChange} />
                                         </span>
                                    </span>
                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Anemia: </span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_anemia_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_anemia_cb}
                                                onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Food Allergy:</span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_food_allergy_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_food_allergy_cb}
                                                onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="parqRowQuarterWidth">
                                        <span className="assessmentPARQ_left_half_quarter_width">Other:</span>
                                        <span className="assessmentPARQ_right_half_quarter_width">
                                            <input
                                                name     = "lifestyle_other_cb"
                                                type     = "checkbox"
                                                className= "assessmentPARQ_checkbox"
                                                checked  = {this.state.lifestyle_other_cb}
                                                onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>

                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowFullWidth" style={{fontSize: 20, textAlign:"left"}}>
                                        <span className="assessmentPARQ_left_half_medium_width">High Triglycerides:</span>
                                    <span className="assessmentPARQ_right_half_quarter_width">
                                              <input
                                                  name     = "lifestyle_high_triglycerides_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.lifestyle_high_triglycerides_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowFullWidth" style={{fontSize: 20, textAlign:"left"}}>
                                        <span className="assessmentPARQ_left_half_medium_width">R.D. Referral:</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                            <input type     = "radio"
                                                   value    = "yes"
                                                   name     = "lifestyle_rd_referral_cb"
                                                   checked  = {this.state.lifestyle_rd_referral_cb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   value    = "no"
                                                   name     = "lifestyle_rd_referral_cb"
                                                   checked  = {this.state.lifestyle_rd_referral_cb === "no"}
                                                   onChange = {this.handleInputChange}/> &nbsp; No
                                        </span>
                                    </span>
                        </div>
                        { /***********************  END: LIFESTYLE  ***************************/ }
                        { /********************************************************************/ }

                        { /********************************************************************/ }
                        { /***********************  HEALTH QESTIONS  ***************************/ }
                        <div className="parqSectionTitle">
                            <FontAwesomeIcon icon="notes-medical" className="parqHealthIcon" />
                            <span className="parqHealthTitle">
                                 Health Questions
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">
                                    <span className="assessmentPARQ_row_long">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Has your doctor ever said that you have a heart condition and that you should only do physical activity recommended by a doctor?</span>

                                        <span className="assessmentPARQ_right_half_health">
                                            <input type     = "radio"
                                                     value    = "no"
                                                     name     = "health_heart_condition_rb"
                                                     checked  = {this.state.health_heart_condition_rb === "no"}
                                                     onChange = {this.handleInputChange}/> &nbsp; No
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   name     = "health_heart_condition_rb"
                                                   value    = "yes"
                                                   checked  = {this.state.health_heart_condition_rb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                        </span>
                                    </span>
                                    <span className="assessmentPARQ_row_long_colored">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Do you feel pain in your chest when you do physical ativity?</span>

                                        <span className="assessmentPARQ_right_half_health">
                                                <input type     = "radio"
                                                         value    = "no"
                                                         name     = "health_chest_pain_during_activity_rb"
                                                         checked  = {this.state.health_chest_pain_during_activity_rb === "no"}
                                                         onChange = {this.handleInputChange}/> &nbsp; No
                                                &nbsp; &nbsp; &nbsp;
                                                <input type     = "radio"
                                                       name     = "health_chest_pain_during_activity_rb"
                                                       value    = "yes"
                                                       checked  = {this.state.health_chest_pain_during_activity_rb === "yes"}
                                                       onChange = {this.handleInputChange} /> &nbsp; Yes
                                            </span>
                                    </span>

                                    <span className="assessmentPARQ_row_long">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">In the last month, have you had chest pain when you were not doing physical activity?</span>

                                        <span className="assessmentPARQ_right_half_health">
                                            <input type     = "radio"
                                                     value    = "no"
                                                     name     = "health_chest_pain_no_activity_rb"
                                                     checked  = {this.state.health_chest_pain_no_activity_rb === "no"}
                                                     onChange = {this.handleInputChange}/> &nbsp; No
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   name     = "health_chest_pain_no_activity_rb"
                                                   value    = "yes"
                                                   checked  = {this.state.health_chest_pain_no_activity_rb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                        </span>
                                    </span>
                                    <span className="assessmentPARQ_row_long_colored">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Do you ever lose your balance because of dizziness or do you ever lose consciousness?</span>

                                            <span className="assessmentPARQ_right_half_health">
                                                <input type     = "radio"
                                                         value    = "no"
                                                         name     = "health_dizziness_lose_balance_rb"
                                                         checked  = {this.state.health_dizziness_lose_balance_rb === "no"}
                                                         onChange = {this.handleInputChange}/> &nbsp; No
                                                &nbsp; &nbsp; &nbsp;
                                                <input type     = "radio"
                                                       name     = "health_dizziness_lose_balance_rb"
                                                       value    = "yes"
                                                       checked  = {this.state.health_dizziness_lose_balance_rb === "yes"}
                                                       onChange = {this.handleInputChange} /> &nbsp; Yes
                                            </span>
                                    </span>

                                    <span className="assessmentPARQ_row_long">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Do you have a bone or joint problem that could be made worse by a change in physical activity?</span>

                                        <span className="assessmentPARQ_right_half_health">
                                            <input type     = "radio"
                                                     value    = "no"
                                                     name     = "health_joint_problem_rb"
                                                     checked  = {this.state.health_joint_problem_rb === "no"}
                                                     onChange = {this.handleInputChange}/> &nbsp; No
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   name     = "health_joint_problem_rb"
                                                   value    = "yes"
                                                   checked  = {this.state.health_joint_problem_rb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                        </span>
                                    </span>
                                    <span className="assessmentPARQ_row_long_colored">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Is your doctor currently prescribing drugs (for example, water pills) for your blood pressure or hear condition?</span>

                                        <span className="assessmentPARQ_right_half_health">
                                            <input type     = "radio"
                                                     value    = "no"
                                                     name     = "health_blood_pressure_drugs_rb"
                                                     checked  = {this.state.health_blood_pressure_drugs_rb === "no"}
                                                     onChange = {this.handleInputChange}/> &nbsp; No
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   name     = "health_blood_pressure_drugs_rb"
                                                   value    = "yes"
                                                   checked  = {this.state.health_blood_pressure_drugs_rb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_row_long">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Do you know of any other reason why you should not do physical activity?</span>

                                        <span className="assessmentPARQ_right_half_health">
                                            <input type     = "radio"
                                                     value    = "no"
                                                     name     = "health_other_reasons_rb"
                                                     checked  = {this.state.health_other_reasons_rb === "no"}
                                                     onChange = {this.handleInputChange}/> &nbsp; No
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   name     = "health_other_reasons_rb"
                                                   value    = "yes"
                                                   checked  = {this.state.health_other_reasons_rb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_row_long_colored">
                                        <span className="assessmentPARQ_left_half_three_quarter_width">Have you received medical clearance?</span>

                                        <span className="assessmentPARQ_right_half">
                                            <input type     = "radio"
                                                     value    = "no"
                                                     name     = "health_medical_clearance_rb"
                                                     checked  = {this.state.health_medical_clearance_rb === "no"}
                                                     onChange = {this.handleInputChange}/> &nbsp; No
                                            &nbsp; &nbsp; &nbsp;
                                            <input type     = "radio"
                                                   name     = "health_medical_clearance_rb"
                                                   value    = "yes"
                                                   checked  = {this.state.health_medical_clearance_rb === "yes"}
                                                   onChange = {this.handleInputChange} /> &nbsp; Yes
                                        </span>
                                    </span>
                                    <span className="assessmentPARQ_row_long">
                                        <br/>
                                    <span className="assessmentPARQ_left_half_three_quarter_width">If yes, when was clearance received? (mm/dd/yyyy)</span>

                                        <span className="assessmentPARQ_right_half">
                                            <input
                                                  name      = "health_clearance_date_tf"
                                                  //type      = "number"
                                                  className = "assessmentPARQ_textfield_date_width"
                                                  value     = {this.state.health_clearance_date_tf}
                                                  onChange  = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        { /***********************  END: Health  ***************************/ }
                        { /********************************************************************/ }

                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="iconAddExercise25pxVertSpacer"></div>

                        { /**********************************************************************/ }
                        { /***********************  Activity Profile  ***************************/ }
                        <div className="parqSectionTitle">
                            <FontAwesomeIcon icon="running" className="parqActivityIcon" />
                        <span className="parqActivityTitle">
                                 Activity Profile
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth">
                                    <span className="parqRowHalfWidth">
                                        <span className="assessmentPARQ_left_half_short_width">&nbsp;Occupation:</span>
                                    <span className="assessmentPARQ_right_half_long_width"> &nbsp; &nbsp;
                                            <input
                                              name      = "activity_occupation_tf"
                                              className = "assessmentPARQ_textfield_long_width"
                                              value     = {this.state.activity_occupation_tf}
                                              onChange  = {this.handleInputChange} />
                                         </span>
                                    </span>
                                    <span className="parqRowHalfWidth">
                                        <span className="assessmentPARQ_left_half_medium_width">&nbsp;</span>
                                        <span className="assessmentPARQ_right_half_medium_width">&nbsp;</span>
                                    </span>
                        </div>

                        <div className="grid parqRowFullWidth">
                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half">Business/Office Worker:</span>
                                    <span className="assessmentPARQ_right_half_medium_width"> &nbsp; &nbsp;
                                              <input
                                                  name     = "activity_office_worker_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.activity_office_worker_cb}
                                                  onChange = {this.handleInputChange} />
                                         </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">

                                        <span className="assessmentPARQ_left_half_medium_width">Works on Feet:</span>
                                        <span className="assessmentPARQ_right_half_medium_width"> &nbsp;
                                              <input
                                                  name     = "activity_works_on_feet_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.activity_works_on_feet_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>

                                    <span className="assessmentPARQ_labelCB">
                                        <span className="assessmentPARQ_left_half_small_width">Heavy Physical Work: &nbsp;</span>
                                        <span className="assessmentPARQ_right_half_medium_width">
                                              <input
                                                  name     = "activity_heavy_work_cb"
                                                  type     = "checkbox"
                                                  className= "assessmentPARQ_checkbox"
                                                  checked  = {this.state.activity_heavy_work_cb}
                                                  onChange = {this.handleInputChange} />
                                        </span>
                                    </span>
                        </div>
                        <div className="grid parqRowFullWidth">
                                <span className="assessmentPARQ_labelCB">
                                    <span className="assessmentPARQ_left_half_medium_width">Seated Hours/D:</span>
                                    <span className="assessmentPARQ_right_half_medium_width">
                                            <input
                                              name      = "activity_seated_hours_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.activity_seated_hours_tf}
                                              onChange  = {this.handleInputChange} />
                                     </span>
                                </span>

                                <span className="assessmentPARQ_labelCB">

                                    <span className="assessmentPARQ_left_half_medium_width">Standing Hours/D:</span>
                                    <span className="assessmentPARQ_right_half_medium_width">
                                            <input
                                              name      = "activity_standing_hours_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.activity_standing_hours_tf}
                                              onChange  = {this.handleInputChange} />
                                    </span>
                                </span>

                                <span className="assessmentPARQ_labelCB">
                                    <span className="assessmentPARQ_left_medium_half">Commute Time/D:</span>
                                <span className="assessmentPARQ_right_medium_half"> &nbsp; &nbsp;&nbsp;
                                            <input
                                              name      = "activity_commute_time_tf"
                                              type      = "number"
                                              className = "assessmentPARQ_textfield_short_width"
                                              value     = {this.state.activity_commute_time_tf}
                                              onChange  = {this.handleInputChange} />
                                    </span>
                                </span>
                        </div>

                        { /***********************  Activity Profile  ***************************/ }
                        { /**********************************************************************/ }

                        <div className="iconAddExercise25pxVertSpacer"></div>

                        { /***********************************************************/ }
                        { /***********************  Notes  ***************************/ }
                        <div className="parqSectionTitle">

                            <FontAwesomeIcon icon="file-signature" className="parqNotesIcon" />
                        <span className="parqNotesTitle">
                                 Notes
                            </span>
                        </div>
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="grid parqRowFullWidth notes_textarea_box">
                                  <textarea name      = "parq_notes_ta"
                                            className = "assessmentPARQ_textarea"
                                            value     = {this.state.parq_notes_ta}
                                            onChange  = {this.handleInputChange} />
                        </div>

                        { /***********************  Notes  ***************************/ }
                        { /***********************************************************/ }

                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <div className="iconAddExercise25pxVertSpacer"></div>

                        <Row className="grid" >
                              <Col xs={6} sm={6} md={6}>
                                    <span onClick = { () => this.props.cancelAssessment()}
                                        style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                          <LoaderButton
                                            block
                                            type    = "button"
                                            text    = "Cancel"
                                            style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                          />
                                    </span>
                              </Col>
                              <Col xs={6} sm={6} md={6}>
                                    <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                          <LoaderButton
                                            block
                                            style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                            //disabled={!this.validateForm()}
                                            isLoading={this.state.isLoading}
                                            text    = "Save"
                                            type    = "submit"
                                            loadingText="Saving …"
                                          />
                                    </span>
                                </Col>
                         </Row>


                </form>

             {/*} </Form>*/ }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/PARQForm.js